let language = {
    ADDRESS_VIEWER_FORM_FIRST_NAME_LABEL: "名:",
    ADDRESS_VIEWER_FORM_LAST_NAME_LABEL: "姓:",
    ADDRESS_VIEWER_FORM_COUNTRY_REGION_LABEL: "国家/地区:",
    ADDRESS_VIEWER_FORM_STATE_PROVINCE_LABEL: "州/省:",
    ADDRESS_VIEWER_FORM_CITY_TOWN_LABEL: "城市/城镇:",
    ADDRESS_VIEWER_FORM_EMAIL_LABEL: "电子邮箱:",
    ADDRESS_VIEWER_FORM_EMAIL_ERROR_TIP1: "不能为空!",
    ADDRESS_VIEWER_FORM_EMAIL_ERROR_TIP2: "无效的电子邮箱!",
    ADDRESS_VIEWER_FORM_LOCATION_LABEL: "位置类型:",
    ADDRESS_VIEWER_FORM_PHONE1_LABEL: "电话1:",
    ADDRESS_VIEWER_FORM_PHONE2_LABEL: "电话2:",
    ADDRESS_VIEWER_FORM_POSTCODE_LABEL: "邮政编码:",
    ADDRESS_VIEWER_FORM_POSTCODE_ERROR_TIP1: "不能为空!",
    ADDRESS_VIEWER_FORM_POSTCODE_ERROR_TIP2: "无效的邮政编码!",
    ADDRESS_VIEWER_FORM_ADDRESS1_LABEL: "地址1:",
    ADDRESS_VIEWER_FORM_ADDRESS2_LABEL: "地址2:",
    ADDRESS_VIEWER_FORM_ADDRESS_TAG_LABEL: "地址标签:",
    ADDRESS_VIEWER_FORM_SET_AS_DEFAULT_CHECKBOX: "设为默认",

    
};

export { language }